import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  public transform(value: string, limit = 25, completeWords = false, ellipsis = '...') {
    if (!value || !limit) {
      return value;
    }

    if (completeWords) {
      limit = value.substr(0, 13).lastIndexOf(' ');
    }
    if (value.substr(0, limit).length >= value.length) {
      ellipsis = '';
    }
    return `${value.substr(0, limit)}${ellipsis}`;
  }
}
